/**
 * @generated SignedSource<<4589d2b4171d83b7ae889558167364fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentsMethodsListContentBestInstallment_PaymentOption$data = {
  readonly total: {
    readonly amount: number;
  };
  readonly " $fragmentSpreads": FragmentRefs<"utils_PaymentOption">;
  readonly " $fragmentType": "PaymentsMethodsListContentBestInstallment_PaymentOption";
};
export type PaymentsMethodsListContentBestInstallment_PaymentOption$key = {
  readonly " $data"?: PaymentsMethodsListContentBestInstallment_PaymentOption$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentsMethodsListContentBestInstallment_PaymentOption">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "amount",
    "storageKey": null
  }
],
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Money",
  "kind": "LinkedField",
  "name": "total",
  "plural": false,
  "selections": (v0/*: any*/),
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentsMethodsListContentBestInstallment_PaymentOption",
  "selections": [
    (v1/*: any*/),
    {
      "kind": "InlineDataFragmentSpread",
      "name": "utils_PaymentOption",
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "PaymentOptionInstallmentConnection",
          "kind": "LinkedField",
          "name": "installments",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PaymentOptionInstallmentEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PaymentOptionInstallment",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "interestRate",
                      "storageKey": null
                    },
                    (v1/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Money",
                      "kind": "LinkedField",
                      "name": "value",
                      "plural": false,
                      "selections": (v0/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "PaymentOption",
  "abstractKey": null
};
})();

(node as any).hash = "04673eaae789cc3c911619618394c628";

export default node;
